import { Action, createAction } from 'redux-act';

import EnableReservationsResult from '../../../models/interfaces/EnableReservationsResult';
import TimestampPayload from '../TimestampPayload';

export interface EnableReservationsPayload {
  token: string;
  enable: boolean;
}
export const enableReservations = createAction<EnableReservationsPayload>('ENABLE_RESERVATIONS');
export type EnableReservationsActionType = Action<EnableReservationsPayload>;

export interface EnableReservationsResultPayload extends TimestampPayload {
  enableReservationsResult: EnableReservationsResult;
  placeUniqueName?: string;
  token: string;
}
export const enableReservationsFinished = createAction<EnableReservationsResultPayload>('ENABLE_RESERVATIONS_FINISHED');
export const enableReservationsFailed = createAction<EnableReservationsResultPayload>('ENABLE_RESERVATIONS_FAILED');
